import { ReactNode, CSSProperties } from 'react'

interface ContainerProps {
  children: ReactNode
  centered?: boolean
  maxWidth?: string
  padding?: string
  style?: CSSProperties
}

export default function Container({ 
  children, 
  centered = false,
  maxWidth = '1280px',
  padding = '2rem 1.5rem',
  style 
}: ContainerProps) {
  return (
    <div style={{
      maxWidth,
      margin: centered ? '0 auto' : undefined,
      padding,
      ...style
    }}>
      {children}
    </div>
  )
}

